<script lang="ts">
  export let title: string = "";
  let isOpen: boolean = false;

  $: activeClass = isOpen ? "is-active" : "";

  function toggleDropdown() {
    isOpen = !isOpen;
  }
</script>

<div class="dropdown {activeClass}">
  <div class="dropdown-trigger">
    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" on:click={toggleDropdown}>
      <span>{title}</span>
      <span class="icon is-small">
        <i class="material-icons"> expand_more </i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content" on:click={toggleDropdown}>
      <slot />
      <!-- <a href="#top" class="dropdown-item"> Dropdown item </a> -->
    </div>
  </div>
</div>
